/**
 * Project : workspace
 * File    : NavigationItem.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.base.tab

import androidx.compose.ui.graphics.vector.ImageVector

data class NavigationItem(
    val title: String,
    val icon: ImageVector,
    val route: String
)